module.exports = __webpack_public_path__ + "img/zk.33002196.jpg";